/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import { getFirstEsRefId } from '@/lib/stackDeployments/selectors/clusters'
import { updateEsMetadata } from '@/actions/stackDeployments/metadata'
import { setDeploymentResourceMetadataRequest } from '@/reducers/asyncRequests/registry'

import ProxyLogging from './ProxyLogging'

import type { ReduxState } from '@/types/redux'
import type { StateProps, ConsumerProps, DispatchProps } from './ProxyLogging'

const mapStateToProps = (state: ReduxState, { deployment }: ConsumerProps): StateProps => {
  const esRefId = getFirstEsRefId({ deployment })
  return {
    setDeploymentResourceMetadataRequest: setDeploymentResourceMetadataRequest(
      state,
      deployment.id,
      `elasticsearch`,
      esRefId,
    ),
  }
}

const mapDispatchToProps: DispatchProps = {
  updateMetadata: updateEsMetadata,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProxyLogging)
